module.exports = __webpack_public_path__ + "static/media/block-top-left.e2577c45.png";